var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#414042"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18188 10.9089H21.8182M13.6364 14.318V17.7271M16.3637 14.318V17.7271M9.54552 10.9089H20.4546L19.3773 20.6044C19.3404 20.938 19.1817 21.2464 18.9316 21.4703C18.6815 21.6942 18.3576 21.818 18.0219 21.818H11.9782C11.6425 21.818 11.3186 21.6942 11.0685 21.4703C10.8184 21.2464 10.6597 20.938 10.6228 20.6044L9.54552 10.9089ZM11.8262 8.96369C11.9365 8.7298 12.111 8.53209 12.3294 8.39363C12.5478 8.25516 12.801 8.18164 13.0596 8.18164H16.9405C17.1992 8.18151 17.4526 8.25497 17.6711 8.39344C17.8897 8.53192 18.0643 8.7297 18.1746 8.96369L19.091 10.9089H10.9092L11.8262 8.96369V8.96369Z",
    stroke: "#F8F9FA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.428cf3736e3e2443455bc889de4dd5f3.svg";
export { ForwardRef as ReactComponent };